import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toBase64, getFileExtension } from '../../../../utils/util';

import {
  requestFindAccount,
  requestReviewCompanyDocuments,
  requestUploadCompanyDocument,
} from '../../../../api/admin/account/admin-account.actions';
import { requestDownloadDocument } from '../../../../api/document/document.actions';

import { retrieveFromLocalStorage } from '../../../../utils/util';

import Account from '../../../../components/screens/admin/account-management/account/Account';

const AccountContainer = () => {
  const { account } = useSelector(({ accountManagement }) => accountManagement);

  const dispatch = useDispatch();

  const { organisationExternalReference } = useParams();

  useEffect(() => {
    dispatch(requestFindAccount({ organisationExternalReference }));
  }, [dispatch, organisationExternalReference]);

  const reviewDocument = (linkedMediaExternalReference, status, message, onSuccess) => {
    const personExternalReference = retrieveFromLocalStorage('personExternalReference');

    const document = {
      adminExternalReference: personExternalReference,
      status: status.charAt(0).toUpperCase() + status.slice(1),
      linkedMediaExternalReference,
      organisationExternalReference,
      message,
    };

    dispatch(
      requestReviewCompanyDocuments({
        document,
        onSuccess: () => {
          dispatch(requestFindAccount({ organisationExternalReference }));
          onSuccess();
        },
      })
    );
  };

  const downloadDocument = (document) => {
    dispatch(
      requestDownloadDocument({
        externalReference: document.linkedMediaExternalReference,
        name: document.name,
      })
    );
  };

  const uploadDocument = async (subject, category, document) => {
    const base64EncodedString = await toBase64(document);
    const documentExtension = getFileExtension(document.name);

    const documentToUpload = {
      companyExternalReference: organisationExternalReference,
      name: document.name,
      documentSubject: subject,
      category,
      base64EncodedString,
      documentExtension,
    };

    dispatch(
      requestUploadCompanyDocument({
        document: documentToUpload,
        onSuccess: () => {
          dispatch(requestFindAccount({ organisationExternalReference }));
        },
      })
    );
  };

  return (
    <Account
      account={account}
      reviewDocument={reviewDocument}
      downloadDocument={downloadDocument}
      uploadDocument={uploadDocument}
    />
  );
};

export default AccountContainer;
